import { render, staticRenderFns } from "./SwiperGallery.vue?vue&type=template&id=65241750&"
import script from "./SwiperGallery.vue?vue&type=script&lang=js&"
export * from "./SwiperGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports